/**
 * Shared rules for membership car registration (VRM stored in member.telephone).
 */

export const normaliseVRM = (vrm) => (vrm ? String(vrm).replace(/\s+/g, '').toUpperCase() : '');

export const isChildMembership = (membership, selectedTickets = []) => {
  const membershipName = (membership.description || membership.alternativeDescription || membership.membershipTypeTitle || '').toLowerCase();

  if (
    membershipName.includes('child') ||
    membershipName.includes('junior') ||
    membershipName.includes('under 3') ||
    membershipName.includes('aged 4') ||
    membershipName.includes('aged 4-16') ||
    membershipName.includes('aged 4 - 16')
  ) {
    return true;
  }

  if (membership.webSaleItemId && selectedTickets?.length > 0) {
    const matchingTicket = selectedTickets.find((t) => t.webSaleItemId === membership.webSaleItemId);
    if (matchingTicket) {
      const ticketName = (matchingTicket.name || matchingTicket.description || '').toLowerCase();
      return (
        ticketName.includes('child') ||
        ticketName.includes('junior') ||
        ticketName.includes('under 3') ||
        ticketName.includes('aged 4') ||
        ticketName.includes('aged 4-16') ||
        ticketName.includes('aged 4 - 16')
      );
    }
  }

  return false;
};

export const isFamilyMembership = (membership, selectedTickets = []) => {
  const membershipName = (membership.description || membership.alternativeDescription || membership.membershipTypeTitle || '').toLowerCase();
  if (membershipName.includes('family')) {
    return true;
  }
  if (membership.webSaleItemId && selectedTickets?.length > 0) {
    const matchingTicket = selectedTickets.find((t) => t.webSaleItemId === membership.webSaleItemId);
    if (matchingTicket) {
      const ticketName = (matchingTicket.name || matchingTicket.description || '').toLowerCase();
      return ticketName.includes('family');
    }
  }
  return false;
};

export const shouldShowCarRegistration = (membership, memberIndex, selectedTickets = []) => {
  if (isChildMembership(membership, selectedTickets)) {
    return false;
  }
  if (isFamilyMembership(membership, selectedTickets)) {
    return memberIndex < 2;
  }
  return membership.displayTelephone === true;
};
